<template>
    <div v-if="question.isShow" class="question-item">
        <!--<div class="question-title"><i v-if="question.isMust">*</i>{{question.title}}</div>-->
        <div class="question-title"><i v-if="question.isMust">*</i>{{question.serialNumber}}.{{question.title}}</div>
        <div v-if="question.note">说明：{{question.note}}</div>
        <div v-if="question.timeConfigArr[0].withBingId">(规则：{{getTimeConfigString(question.timeConfigArr)}})</div>
        <img class="qs-img-preview" :src="question.pictureUrl" alt="">
        <div class="question-option">
            <div class="time-list">
                <div class="time-top">
                    <!--<el-input placeholder="年" type="text" v-model="question.value[0].yearSelect"></el-input>-->
                    <!--<el-input placeholder="月" type="text" v-model="question.value[0].monthSelect"></el-input>-->
                    <!--<el-input placeholder="日" type="text" v-model="question.value[0].daySelect"></el-input>-->
                    <time-picker @changeHandler="changeHandler" :date="question.value[0]"></time-picker>
                </div>
                <div v-if="question.isTime" class="time-item-bottom">
                    <el-input placeholder="时" type="text" v-model="question.value[0].hourSelect"></el-input>
                    <el-input placeholder="分" type="text" v-model="question.value[0].minuteSelect"></el-input>
                </div>
            </div>
            <!--<time-picker :date="question.value[0]"></time-picker>-->
            <div v-if="question.dateCycle">
                <!--<span>{{question.linkWord}}</span>-->
                <span>{{question.linkWord}}</span>
                <div class="time-list">
                    <div class="time-top">
                        <!--<el-input placeholder="年" type="text" v-model="question.value[1].yearSelect"></el-input>-->
                        <!--<el-input placeholder="月" type="text" v-model="question.value[1].monthSelect"></el-input>-->
                        <!--<el-input placeholder="日" type="text" v-model="question.value[1].daySelect"></el-input>-->
                        <time-picker @changeHandler="changeHandler"  :date="question.value[1]"></time-picker>
                    </div>
                    <div v-if="question.isTime" class="time-item-bottom">
                        <el-input placeholder="时" type="text" v-model="question.value[1].hourSelect"></el-input>
                        <el-input placeholder="分" type="text" v-model="question.value[1].minuteSelect"></el-input>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import timePicker from '../../questionItenByTypes/dateTimePicker'
  export default {
    name: 'questionTimeSelect',
    props: {
      question: { required: true },
      patientId: { required: false },
      questionList: { required: true },
    },
    components: {
      timePicker
    },
    computed: {
      QsValue () {
        return this.question.options.filter(item => item.selected)
      }
    },
    watch: {
      'question.isShow': {
        handler (val) {
          if(val) {
            // this.changeValue()
          }
        },
        deep: true,
        immediate: true
      }
    },
    created () {
      this.init()
    },
    methods: {
      changeHandler() {
        this.changeValue()
      },
      getPicture () {
        if (this.question.pictureUrl) {
          this.$store.dispatch('getPicture', { url: [this.question.pictureUrl] })
            .then(res => {
              this.question.pictureUrl = res[0]
            })
        }
      },
      init () {
        this.getAnswer()
        this.getPicture()
      },
      selectHandler (item) {
        if (item.disabled) {
          return false
        }
        item.selected = !item.selected
        this.question.value = item
        this.question.value = this.QsValue
      },
      getTimeConfigString (config) {
        var string = ''
        config.forEach(v => {
          var question = this.questionList.find(item => item.id == v.withBingId)
          string += `${this.getType(v.type)}第${question.serialNumber}题目`
        })
        return string
      },
      getType (type) {
        switch (type) {
          case 3:
            return '早于'
            break
          case 4:
            return '早于或等于'
            break
          case 1:
            return '晚于'
            break
          case 2:
            return '晚于或等于'
            break
        }
      },
      async checkIsFill () {
        var value
        if (this.question.isShow) {
          if (this.question.isMust) {
            value = await this.checkValue()
            return value
          } else {
            return true
          }
        } else {
          return true
        }
      },
      async checkValue () {
        return new Promise(resolve => {
          var res
          this.chekLimitRule()
            .then( async () => {
              if (this.question.dateCycle) {
                if (this.question.value[0].yearSelect && this.question.value[0].daySelect && this.question.value[0].monthSelect
                  && this.question.value[1].yearSelect && this.question.value[1].daySelect && this.question.value[1].monthSelect
                ) {
                  res = await this.checkValueRule()
                  console.log(11111,res)
                } else {
                  res =  false
                }
                resolve(res)
              } else {
                if (this.question.value[0].yearSelect && this.question.value[0].daySelect && this.question.value[0].monthSelect) {
                  res = await this.checkValueRule()
                  console.log(11111,res)
                } else {
                  res =  false
                }
                resolve(res)
              }
            })
        })
      },

      changeValue() {
        if (this.question.bingTimeId && this.question.bingTimeId.length && this.question.value) {
          this.question.bingTimeId.forEach(v => {
            var qs = this.questionList.find(item => item.id == v)
            var configObj = qs.timeConfigArr.find(item => item.withBingId == this.question.id)
            configObj.value = this.timeHandler(this.question.value[0])
            if(this.question.value[0].yearSelect) {
              configObj['valueBefore'] = JSON.parse(JSON.stringify(this.question.value[0]))
            }
          })
        }
      },
      chekLimitRule () {
        return new Promise(resolve => {
          if (this.question.bingTimeId && this.question.bingTimeId.length) {
            this.question.bingTimeId.forEach(v => {
              var qs = this.questionList.find(item => item.id == v)
              var configObj = qs.timeConfigArr.find(item => item.withBingId == this.question.id)
              configObj.value = this.timeHandler(this.question.value[0])
              configObj['valueBefore'] = JSON.parse(JSON.stringify(this.question.value[0]))
            })
          }
          resolve()
        })
      },
      async checkValueRule () {
        var result = await this.chekValueRuleAsync()
        console.log(222222,result)
        // console.log(result,result.findIndex(item => !item) == -1)
        return result.findIndex(item => !item) == -1
        // return !result.findIndex(item => !item) == -1
        // return result.find(item => item === false)
      },
      chekValueRuleAsync () {
        return new Promise(resolve => {
          if (this.question.timeConfigArr[0].withBingId != '') {
            var resultArr = []
            this.question.timeConfigArr.forEach((v) => {
              var questionValue = this.timeHandler(this.question.value[0])
              console.log(questionValue)
              if (questionValue == -1 || v.value == -1) {
                resultArr.push(true)
              } else {
                if (v.valueBefore && v.valueBefore.yearSelect == '不清楚') {
                  resultArr.push(true)
                } else if (v.valueBefore && v.valueBefore.monthSelect == '不清楚') {
                  if (this.question.value[0].yearSelect == v.valueBefore.yearSelect) {
                    resultArr.push(true)
                  } else {
                    if (v.type == 1) {
                      resultArr.push(this.question.value[0].yearSelect > v.valueBefore.yearSelect)
                    } else if (v.type == 2) {
                      resultArr.push(this.question.value[0].yearSelect >= v.valueBefore.yearSelect)
                    } else if (v.type == 3) {
                      resultArr.push(this.question.value[0].yearSelect < v.valueBefore.yearSelect)
                    } else if (v.type == 4) {
                      resultArr.push(this.question.value[0].yearSelect <= v.valueBefore.yearSelect)
                    }
                  }
                } else if (v.valueBefore && v.valueBefore.daySelect == '不清楚') {
                  if (this.question.value[0].yearSelect == v.valueBefore.yearSelect && this.question.value[0].monthSelect == v.valueBefore.monthSelect) {
                    resultArr.push(true)
                  } else {
                    if (v.type == 1) {
                      resultArr.push(questionValue > v.value)
                    } else if (v.type == 2) {
                      resultArr.push(questionValue >= v.value)
                    } else if (v.type == 3) {
                      resultArr.push(questionValue < v.value)
                    } else if (v.type == 4) {
                      resultArr.push(questionValue <= v.value)
                    }
                  }
                } else if (this.question.value[0].monthSelect == '不清楚') {
                  var yearB = new Date(v.value).getFullYear()
                  if (this.question.value[0].yearSelect == yearB) {
                    resultArr.push(true)
                  } else {
                    if (v.type == 1) {
                      resultArr.push(this.question.value[0].yearSelect > yearB)
                    } else if (v.type == 2) {
                      resultArr.push(this.question.value[0].yearSelect >= yearB)
                    } else if (v.type == 3) {
                      resultArr.push(this.question.value[0].yearSelect < yearB)
                    } else if (v.type == 4) {
                      resultArr.push(this.question.value[0].yearSelect <= yearB)
                    }
                  }
                } else if (this.question.value[0].daySelect == '不清楚') {
                  var yearB = new Date(v.value).getFullYear()
                  var monthB = new Date(v.value).getMonth() + 1
                  if (this.question.value[0].yearSelect == yearB && this.question.value[0].monthSelect == monthB) {
                    resultArr.push(true)
                  } else {
                    if (v.type == 1) {
                      resultArr.push(questionValue > v.value)
                    } else if (v.type == 2) {
                      resultArr.push(questionValue >= v.value)
                    } else if (v.type == 3) {
                      resultArr.push(questionValue < v.value)
                    } else if (v.type == 4) {
                      resultArr.push(questionValue <= v.value)
                    }
                  }
                } else {
                  if (v.type == 1) {
                    resultArr.push(questionValue > v.value)
                  } else if (v.type == 2) {
                    resultArr.push(questionValue >= v.value)
                  } else if (v.type == 3) {
                    resultArr.push(questionValue < v.value)
                  } else if (v.type == 4) {
                    resultArr.push(questionValue <= v.value)
                  }
                }

              }
            })
            resolve(resultArr)
          } else {
            resolve([true])
          }
        })

      },
      timeHandler (time) {
        /**
         *
         *  daySelect: 30
         hourSelect: ""
         minuteSelect: ""
         monthSelect: 3
         yearSelect: 2021
         */
        var _item = JSON.parse(JSON.stringify(time))
        if (_item.yearSelect == '不清楚') {
          return -1
        } else if (_item.monthSelect == '不清楚') {
          return new Date(`${_item.yearSelect}-01-01`).getTime()
        } else if (_item.monthSelect == '上半年') {
          return new Date(`${_item.yearSelect}-03-15`).getTime()
        } else if (_item.monthSelect == '下半年') {
          return new Date(`${_item.yearSelect}-09-15`).getTime()
        } else if (_item.daySelect == '不清楚') {
          return new Date(`${_item.yearSelect}-${_item.monthSelect}-01`).getTime()
        } else {
          return new Date(`${_item.yearSelect}-${_item.monthSelect}-${_item.daySelect}`).getTime()
        }

      },
      saveAnswer () {
        return new Promise((resolve => {
          var params = {
            operatorId: localStorage.getItem('huidrUserId'),
            questionInfo: this.question.id,
            questionnaireNewId: this.question.questionnaireNewId,
            answerInfo: JSON.stringify(this.question.value),
            id: this.question.patientAnswerInfoId || null,
            patientId: this.patientId || null,
            questionType: this.question.type||null,
          }
            if (this.$route.query.abnormal=='5') {
              params.isRecord  = true
            }else {
              params.isRecord  = false
            }
          if (this.question.answerInfo) {
            this.$store.dispatch('updateQuestionAnswer', params)
              .then(resolve())
          } else {
            this.$store.dispatch('saveQuestionAnswer', params)
              .then(resolve())
          }
          ////console.log(params)
        }))
      },
      getAnswer () {
        if (this.question.hasOwnProperty('value')) {
          this.question.value = this.question.value
        } else {
          this.question.value = [{
            yearSelect: '',
            monthSelect: '',
            daySelect: '',
            hourSelect: '',
            minuteSelect: '',
          }, {
            yearSelect: '',
            monthSelect: '',
            daySelect: '',
            hourSelect: '',
            minuteSelect: '',
          }]
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
    @import "questionCommon";

    .question-option {
        display: flex;
        flex-direction: column;
        align-items: flex-start !important;

        .option-title {
            display: flex;
            align-items: center;

            .disabled {
                color: #ccc;
            }

            span {
                font-size: 16px;
                margin-left: 10px;
            }
        }

        .time-list {
            display: flex;

            .time-top {
                display: flex;
            }

            .time-item-bottom {
                display: flex;
            }

        }

        .option-other {

        }
    }


</style>